import { render, staticRenderFns } from "./UserMypage.vue?vue&type=template&id=973c9b38&scoped=true&"
import script from "./UserMypage.vue?vue&type=script&lang=js&"
export * from "./UserMypage.vue?vue&type=script&lang=js&"
import style0 from "./UserMypage.vue?vue&type=style&index=0&id=973c9b38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973c9b38",
  null
  
)

export default component.exports